module.exports = __webpack_public_path__ + "static/media/order4.79890239.png";